// extracted by mini-css-extract-plugin
export default {"footer_container":"App_footer_container__MBtuY","nav_container":"App_nav_container__9V-bJ","whatsapp_container":"App_whatsapp_container__No47N"};